import * as React from 'react';
import { FinancialModelCreateUnauthenticatedInput, FinancialModelUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useUpdateFinancialModelCallback } from './useUpdateFinancialModelCallback';
import { FinancialModel } from '../models/FinancialModel';
import { useCreateFinancialModelUnauthenticatedCallback } from './useCreateFinancialModelUnauthenticatedCallback';

/**
 * Get a callback to save a FinancialModel in the store when the user is not authenticated - will always use create but left update in so we could use it in future.
 */
export function useSaveFinancialModelUnauthenticatedCallback(options: SaveInStoreOptions<FinancialModel, string> = {}) {
    const [_create, createStatus] = useCreateFinancialModelUnauthenticatedCallback();
    const create = React.useCallback((model: Partial<FinancialModel>) => _create(model as FinancialModelCreateUnauthenticatedInput), [_create]);

    const [_update, updateStatus] = useUpdateFinancialModelCallback();
    const update = React.useCallback((id: string, changes: Partial<FinancialModel>) => _update(id, changes as FinancialModelUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
